import React from 'react';
import TweenOne from 'rc-tween-one';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { RightOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import QueueAnim from 'rc-queue-anim';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';

export default function Page2() {
  return (
    <ScrollOverPack
      id="page2"
      className="content-wrapper page"
    >
      <Row justify='center'>
        <Col className='page-box' xs={20} sm={16} md={12} lg={11} xl={11}>
          <QueueAnim
            className="text-wrapper left-text"
            key="text"
            duration={450}
            type="bottom"
            leaveReverse
          >
            <h2 key="h2">轻巧身材，重磅实力</h2>
            <p key="p">
              P系列无人机凭借更优的结构和空气动力学设计，有出色的抗风性能，经实验室测试，可承受最大6个g负载；其载重和续航能力为15kg级纯电动无人机之最。
            </p>
            <div className="param" style={{ marginTop: 70 }}>
              {/*<Row key="row1">*/}
              {/*  <Col span="8" style={{marginBottom:40}}>*/}
              {/*    <h2><Texty>4h</Texty></h2>*/}
              {/*    <h4><Texty>max flight time</Texty></h4>*/}
              {/*  </Col>*/}
              {/*  <Col span="8">*/}
              {/*    <h2><Texty>6kg</Texty></h2>*/}
              {/*    <h4><Texty>max payload</Texty></h4>*/}
              {/*  </Col>*/}
              {/*  <Col span="8">*/}
              {/*    <h2><Texty>5000m</Texty></h2>*/}
              {/*    <h4><Texty>max flight height</Texty></h4>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              {/*<Row key="row2">*/}
              {/*  <Col span="12">*/}
              {/*    <h2><Texty>Level 6</Texty></h2>*/}
              {/*    <h4><Texty>max wind resistance</Texty></h4>*/}
              {/*  </Col>*/}
              {/*  <Col span="12">*/}
              {/*    <h2><Texty>36m/s</Texty></h2>*/}
              {/*    <h4><Texty>max flight speed</Texty></h4>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
            </div>
          </QueueAnim>
        </Col>
        <Col className='page-box' xs={20} sm={16} md={12} lg={11} xl={11}>
          <TweenOne
            key="image"
            className="image2 image-wrapper"
            animation={{ x: 0, opacity: 1, ease: 'easeOutQuad' }}
            style={{ transform: 'translateX(100px)', opacity: 0 }}
          />
        </Col>
      </Row>
    </ScrollOverPack>
  );
}
